import { application } from '@core/controllers/app';

application.register('customers--form', require('./customers/form_controller').default);
